<template lang="pug">
.permission-update-form
  v-form(ref="form")
    v-container
      v-layout
        v-flex
          v-text-field(
            :value="displayName"
            label="會員姓名"
            disabled)
      v-layout(wrap)
        v-flex(
          xs12
          sm4)
          v-select(
            v-model="role"
            :items="activeRoleItems"
            item-value="value"
            item-text="text"
            label="管理權限*"
            outline
            @input="$v.role.$touch()"
            @blur="$v.role.$touch()")
        v-flex(
          v-if="role === 'director'"
          xs12
          sm4)
          v-select(
            v-model="manageRegion"
            :items="regionItems"
            :error-messages="manageRegionErrors"
            item-value="value"
            item-text="text"
            label="負責區域*"
            chips
            multiple
            outline
            @input="$v.manageRegion.$touch()"
            @blur="$v.manageRegion.$touch()")
      form-actions(
        :loading="formMixin_loading"
        @cancel="$emit('cancel')"
        @submit="submit") {{ formMixin_message }}
    check-dialog(:open="checkDialog"
      title="權限修改成功"
      @check="$emit('update-succeed')")
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { formMixin } from "@/mixins";
import ref from "@/utils/validators/ref";
import REGIONS from "@/assets/tables/regions.json";
import ROLES from "@/assets/tables/roles.json";
import CheckDialog from "@/components/core/CheckDialog.vue";

export default {
  name: "PermissionUpdateForm",
  mixins: [validationMixin, formMixin],
  validations: {
    role: {},
    manageRegion: {
      required: ref("role", (value, ref) =>
        ref === "director" ? !!value : true
      )
    }
  },
  components: {
    CheckDialog
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      roleItems: [
        "none",
        "director",
        "north_director",
        "south_director",
        "all_director",
        "counselor",
        "manager",
        "admin"
      ].map(v => ROLES[v]),
      regionItems: Object.entries(REGIONS).map(v => v[1]),
      uid: this.user.uid,
      displayName: this.user.displayName,
      role: this.user.role || null,
      manageRegion: this.user.manageRegion,
      checkDialog: false
    };
  },
  computed: {
    ...mapGetters("auth", ["permissionLevel"]),
    activeRoleItems() {
      return this.roleItems.filter(o => this.permissionLevel >= o.level);
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.role.$dirty) return errors;
      !this.$v.role.required && errors.push("請選擇管理權限");
      return errors;
    },
    manageRegionErrors() {
      const errors = [];
      if (!this.$v.manageRegion.$dirty) return errors;
      !this.$v.manageRegion.required && errors.push("請選擇區主委負責區域");
      return errors;
    }
  },
  methods: {
    async submit() {
      const res = await this.formMixin_submit(
        ["role", "manageRegion"],
        "put",
        `user/${this.user.uid}/permission`
      );
      if (res.succeed) {
        this.checkDialog = true;
      }
    }
  }
};
</script>
